import React from 'react'
import Create from '../crud/create'
import fields from './fields'

const CreateQuestion = (props) => {
  return (
    <Create
// @ts-ignore
      title='Create Question'
      fields={fields}
      apiPath='admin/questions'
      successRedirectPath={resource => `/write-now/questions/${resource.id}/edit`}
    />
  )
}

export default CreateQuestion
